/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_KettlebellInputs */

const en_us2_onboarding_equipment_kettlebell = /** @type {(inputs: Onboarding_Equipment_KettlebellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kettlebells`)
};

const pt_br2_onboarding_equipment_kettlebell = /** @type {(inputs: Onboarding_Equipment_KettlebellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kettlebell`)
};

const es_419_onboarding_equipment_kettlebell = /** @type {(inputs: Onboarding_Equipment_KettlebellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesas rusas`)
};

const pt_pt2_onboarding_equipment_kettlebell = /** @type {(inputs: Onboarding_Equipment_KettlebellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kettlebells`)
};

const fr_fr2_onboarding_equipment_kettlebell = /** @type {(inputs: Onboarding_Equipment_KettlebellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kettlebells`)
};

const de_de2_onboarding_equipment_kettlebell = /** @type {(inputs: Onboarding_Equipment_KettlebellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kettlebells`)
};

const it_it2_onboarding_equipment_kettlebell = /** @type {(inputs: Onboarding_Equipment_KettlebellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kettlebell`)
};

/**
* | output |
* | --- |
* | "Kettlebells" |
*
* @param {Onboarding_Equipment_KettlebellInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_kettlebell = /** @type {((inputs?: Onboarding_Equipment_KettlebellInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_KettlebellInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_kettlebell(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_kettlebell(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_kettlebell(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_kettlebell(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_kettlebell(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_kettlebell(inputs)
	return en_us2_onboarding_equipment_kettlebell(inputs)
});
export { onboarding_equipment_kettlebell as "onboarding.equipment.kettlebell" }